
import { useEffect } from 'react';
import { ContentItem } from '../../../content-card/types';
import { useThumbnailExtraction } from '@/hooks/useThumbnailExtraction';

export const useThumbnailPrefetch = (contentItems: ContentItem[]) => {
  const { processAllPendingThumbnails } = useThumbnailExtraction();

  useEffect(() => {
    // Skip if there are no content items
    if (!contentItems || contentItems.length === 0) {
      return;
    }

    // Find items with missing thumbnails
    const missingThumbnails = contentItems.filter(
      item => !item.thumbnail_url || item.thumbnail_url.trim() === ''
    );
    
    // If there are missing thumbnails, request them to be generated
    if (missingThumbnails.length > 0) {
      console.log(`Found ${missingThumbnails.length} items without thumbnails, requesting extraction`);
      
      // Slight delay before requesting to avoid overwhelming the system
      const timeoutId = setTimeout(() => {
        processAllPendingThumbnails()
          .then(result => {
            console.log('Thumbnail extraction completed:', result);
          })
          .catch(error => {
            console.error('Error extracting thumbnails:', error);
          });
      }, 2000);
      
      return () => clearTimeout(timeoutId);
    }
  }, [contentItems, processAllPendingThumbnails]);
};
